	import Vue from 'vue'
	import Router from 'vue-router'
	Vue.use(Router)
	// 懒加载方式，当路由被访问的时候才加载对应组件
	const Home = resolve => require(['@/pages/Home1'], resolve)
	const Nav = resolve => require(['@/pages/Nav/Nav1'], resolve)

	const Login = resolve => require(['@/pages/Login'], resolve)
	const Content3 = resolve => require(['@/pages/Content3'], resolve)
	const sendMail = resolve => require(['@/pages/email/SendMail'], resolve)
//	const StaffTable = resolve => require(['@/pages/user/staffTable'], resolve)
	const UserList = resolve => require(['@/pages/user/userlist'], resolve)
	const batchCreatUser = resolve => require(['@/pages/user/batchCreatUser'], resolve)
	const batchProvideWelfare = resolve => require(['@/pages/user/batchProvideWelfare'], resolve)
	const EditUser = resolve => require(['@/pages/user/edituser'], resolve)
	const FirPage = resolve => require(['@/pages/firPage'], resolve)
	const manageInfo = resolve => require(['@/pages/system/manageInfo'], resolve)
	const editPwd = resolve => require(['@/pages/system/editPwd'], resolve)
	const addCompanyAdmin = resolve => require(['@/pages/system/addCompanyAdmin'], resolve)
	const getSysuserList = resolve => require(['@/pages/system/getSysuserList'], resolve)
	const getSysRoleList = resolve => require(['@/pages/system/getSysRoleList'], resolve)
	const productList = resolve => require(['@/pages/commodity/productList'], resolve)
	const productClass = resolve => require(['@/pages/commodity/productClass'], resolve)
	const oPtionProduct = resolve => require(['@/pages/commodity/oPtionProduct'], resolve)
	const citys = resolve => require(['@/pages/commodity/citys'], resolve)
	const suppliers = resolve => require(['@/pages/commodity/suppliers'], resolve)
	const ZoneManage = resolve => require(['@/pages/commodity/zoneManage'], resolve)
	const ManageRecharge = resolve => require(['@/pages/system/manageRecharge'], resolve)
	const RechargeRecord = resolve => require(['@/pages/system/rechargeRecord'], resolve)
	const UserGroup = resolve => require(['@/pages/system/userGroup'], resolve)
	
	const OrderImport = resolve => require(['@/pages/order/orderImport'], resolve)
	const Mapping = resolve => require(['@/pages/order/mapping'], resolve)
	
	
	const OrderSelect = resolve => require(['@/pages/order/orderSelect'], resolve)   /*订单查询*/
	const UserAddressRouteManager = resolve => require(['@/pages/order/userAddressRouteManager'], resolve)   /*地址线路管理*/
	const DistributionRouteManager = resolve => require(['@/pages/order/distributionRouteManager'], resolve)   /*地址配送线路管理*/
	const OrderDetail = resolve => require(['@/pages/order/orderDetail'], resolve)   /*地址配送线路管理*/  
	
	
	const OrderPartDistdribution = resolve => require(['@/pages/order/orderPartDistdribution'], resolve)   /*子订单配货*/    
	const PartDeliverGoods = resolve => require(['@/pages/order/partDeliverGoods'], resolve)   /*子订单发货*/    
	const PartExpressImport = resolve => require(['@/pages/order/partExpressImport'], resolve)   /*子订单快递单录入*/    
	const PartConfirmDelivery = resolve => require(['@/pages/order/partConfirmDelivery'], resolve)   /*子订单确认送达*/    
	const PartRefundOnStorehouse = resolve => require(['@/pages/order/partRefundOnStorehouse'], resolve)   /*子订单退单*/
	const DistdributionPrint = resolve => require(['@/pages/order/distdributionPrint'], resolve)   /*预览备货单*/
	const DeliverPrintPartInfos = resolve => require(['@/pages/order/deliverPrintPartInfos'], resolve)   /*预览出货单*/
	
	
	
	
	
	
	/*商品推送*/
	const ProductPush = resolve => require(['@/pages/pushProduct/productPush'], resolve)   /*商品推送*/
	const PushList = resolve => require(['@/pages/pushProduct/pushList'], resolve)   /*推送列表*/
	const OrderCount = resolve => require(['@/pages/pushProduct/orderCount'], resolve)   /*推送列表*/
	
	/*库存*/
	const StockGoods = resolve => require(['@/pages/stock/stockGoods'], resolve)   /*推送列表*/
	
	
	const NotFind = resolve => require(['@/pages/notFind'], resolve)

import { SStorage } from "../js/LStorage"
	// 定义并实例化路由
	let router = new Router({
		/*mode: 'history',*/
		base: __dirname,
//		base: '/vuethink/',
		routes: [{
				path: '/login',
				name: '登录',
				menuShow: false,
				component: Login
			},
			{
				path: '/distdributionPrint',
				name: '预览备货单',
				menuShow: false,
				component: DistdributionPrint
			},
			{
				path: '/deliverPrintPartInfos',
				name: '预览出货单',
				menuShow: false,
				component: DeliverPrintPartInfos
			},
			{
				path: '/',
				menuShow: false,
				redirect: '/user/userlist'
			},
			{
				path: '/user',
				redirect: '/user/userlist',
				menuShow: false,
			},
			{
				path: '/commodity',
				redirect: '/commodity/productList',
				menuShow: false,
			},
			{
				path: '/e-mail',
				redirect: '/e-mail/sendmail',
				menuShow: false,
			},
			{
				path: '/system',
				redirect: '/system/manageInfo',
				menuShow: false,
			},
			{
				path: '/test',
				redirect: '/test/evaluationStandard',
				menuShow: false,
				
			},
			{
				path: '/',
				component: Home,
				menuShow: true,
				children: [{
						path: '/perInfo',
						name: '个人信息',
						component: Content3,
						menuShow: false
					},
					//			{
					//				path: '/firPage',
					//				name: '首页',
					//				menuShow: false,
					//				component: FirPage
					//			},
					{
						path: '/order',
						name: '订单',
						component: Nav,
						iconCls: 'iconfont icon-home', // 图标样式class
						menuShow: true,
						children: [
							{ path: '/order/orderImport', component: OrderImport, name: '订单导入', menuShow: true },
							{ path: '/order/mapping', component: Mapping, name: '多平台商品映射', menuShow: true },
							
							
							{ path: '/order/orderSelect', component: OrderSelect, name: '订单查询', menuShow: true },
							{ path: '/order/userAddressRouteManager', component: UserAddressRouteManager, name: '地址线路管理', menuShow: true },
							{ path: '/order/distributionRouteManager', component: DistributionRouteManager, name: '地址配送线路管理', menuShow: true },
							{ path: '/order/orderDetail', component: OrderDetail, name: '订单详情', menuShow: true },
							
							{ path: '/order/orderPartDistdribution', component: OrderPartDistdribution, name: '子订单配货', menuShow: true },
							{ path: '/order/partDeliverGoods', component: PartDeliverGoods, name: '子订单发货', menuShow: true },
							{ path: '/order/partExpressImport', component: PartExpressImport, name: '子订单快递单录入', menuShow: true },
							{ path: '/order/partConfirmDelivery', component: PartConfirmDelivery, name: '子订单确认送达', menuShow: true },
							{ path: '/order/partRefundOnStorehouse', component: PartRefundOnStorehouse, name: '子订单退单', menuShow: true },
							
						]
					},
					{
						path: '/user',
						name: '员工/福粒',
						component: Nav,
						iconCls: 'iconfont icon-home', // 图标样式class
						menuShow: true,
						children: [
							{ path: '/user/userlist', component: UserList, name: '员工列表', menuShow: true },
							//					{path: '/user/stafftable',component: StaffTable,name:'批量操作',menuShow: true},
							{ path: '/user/batchCreatUser', component: batchCreatUser, name: '批量创建用户', menuShow: true },
							{ path: '/user/batchProvideWelfare', component: batchProvideWelfare, name: '批量发放福利', menuShow: true },
							{ path: '/user/edituser', component: EditUser, name: '修改员工信息', menuShow: false }
						]
					},
					{
						path: '/commodity',
						name: '商品管理',
						component: Nav,
						iconCls: 'iconfont icon-home', // 图标样式class
						menuShow: true,
						children: [
							{ path: '/commodity/productList', component: productList, name: '商品列表', menuShow: true },
							{ path: '/commodity/oPtionProduct', component: oPtionProduct, name: '添加/修改商品属性', menuShow: false },
							{ path: '/commodity/productClass', component: productClass, name: '商品分类', menuShow: true },
							{ path: '/commodity/citys', component: citys, name: '城市群管理', menuShow: true },
							{ path: '/commodity/suppliers', component: suppliers, name: '供应商管理', menuShow: true },
							{ path: '/commodity/zoneManage', component: ZoneManage, name: '商品集合管理', menuShow: true }
						]
					},
					{
						path: '/stock',
						name: '库存',
						component: Nav,
						iconCls: 'iconfont icon-home', // 图标样式class
						menuShow: true,
						children: [
							{ path: '/stock/stockGoods', component: StockGoods, name: '库存商品列表', menuShow: true },
						]
					},
					{
						path: '/e-mail',
						name: '邮件',
						component: Nav,
						iconCls: 'iconfont icon-home', // 图标样式class
						menuShow: true,
						children: [
							{ path: '/e-mail/sendmail', component: sendMail, name: '邮件发送', menuShow: true }
						]
					},
					{
						path: '/system',
						name: '系统管理',
						component: Nav,
						iconCls: 'iconfont icon-home', // 图标样式class
						menuShow: true,
						children: [
							{ path: '/system/getSysRoleList', component: getSysRoleList, name: '角色管理', menuShow: true },
							{ path: '/system/getSysuserList', component: getSysuserList, name: '管理员列表', menuShow: true },
							{ path: '/system/manageRecharge', component: ManageRecharge, name: '管理员充值', menuShow: true },
							{ path: '/system/rechargeRecord', component: RechargeRecord, name: '充值记录', menuShow: true },
							{ path: '/system/manageInfo', component: manageInfo, name: '个人资料', menuShow: true },
							{ path: '/system/editPwd', component: editPwd, name: '修改密码', menuShow: true },
							{ path: '/system/userGroup', component: UserGroup, name: '修改用户专区', menuShow: true }
//							{ path: '/system/addCompanyAdmin', component: addCompanyAdmin, name: '添加管理员', menuShow: true },
							
							
							
							
						]
					},
					
					{     /*推送*/
						path: '/pushProduct',
						name: '融易联',
						component: Nav,   
						iconCls: 'iconfont icon-home', // 图标样式class
						menuShow: true,
						children: [
							{ path: '/pushProduct/productPush', component: ProductPush, name: '商品推送', menuShow: true },
							{ path: '/pushProduct/pushList', component: PushList, name: '商品列表', menuShow: true },
							{ path: '/pushProduct/orderCount', component: OrderCount, name: '订单统计', menuShow: true },
						]
					}
					
				]
			},
			{ path: '*', menuShow: false, component: NotFind }
		]
	});
	router.beforeEach((to, from, next) => {
		if(to.path == '/login') {
			window.sessionStorage.removeItem('access-user');
			router.app.$store.commit('keepAdminUserInfo',{});
			router.app.$store.commit('setGeneralInfo',{});
			next();
		} else {
			if(router.app.$store.state.adminUserInfo.adminId){
				next();
			}else{
				if(!SStorage.getItem('access-user')){
					next({path: '/login'});
				}else{
					router.app.$store.commit('keepAdminUserInfo',SStorage.getItem('access-user'));
					router.app.$store.commit('setGeneralInfo',{adminId:SStorage.getItem('access-user').adminId});
					next();
				}
			}
			
			
			
//			let user = SStorage.getItem('access-user');
////			let user = JSON.parse(window.sessionStorage.getItem('access-user'));
//			if(!user) {
//				next({
//					path: '/login'
//				});
//			} else {
////				router.app.$store.commit('keepAdminUserInfo',SStorage.getItem('access-user'));
//				next();
//			}
//			next();
			
			
			
			
			
			
		}
	});
	export default router


// WEBPACK FOOTER //
// ./src/router/index.js